import { render } from "./LoanDetail.vue?vue&type=template&id=771e41e0&scoped=true"
import script from "./LoanDetail.vue?vue&type=script&lang=js"
export * from "./LoanDetail.vue?vue&type=script&lang=js"

import "./LoanDetail.vue?vue&type=style&index=0&id=771e41e0&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771e41e0"]])

export default __exports__